import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { PaginationInput, PurchaseOrderFilterInput } from '@/gql/graphql';
import { PAGINATION_ARG_DEFAULTS } from '@payaca/shared-isomorphic/constants/graphql-pagination';

import stockLocationKeys from './keyFactory';

const GetStockLocationPurchaseOrders = graphql(`
  query StockLocationPurchaseOrders(
    $id: ID!
    $input: PurchaseOrderFilterInput
    $pagination: PaginationInput!
  ) {
    stockLocation(id: $id) {
      id
      materialsList {
        id
        purchaseOrders(input: $input, pagination: $pagination) {
          items {
            __typename
            id
            reference
            status
            supplier {
              id
              name
            }
            totals {
              predictedValueExcTax {
                value
                currency {
                  id
                  code
                  exponent
                }
              }
              purchasedValueExcTax {
                value
                currency {
                  id
                  code
                  exponent
                }
              }
            }
            ... on PurchaseOrderCityPlumbing {
              cityPlumbingOrder {
                orderId
                status
              }
            }
          }
          totalCount
          offset
          limit
        }
      }
    }
  }
`);

const useGetStockLocationPurchaseOrders = (
  id: string | undefined,
  input?: PurchaseOrderFilterInput,
  pagination: PaginationInput = PAGINATION_ARG_DEFAULTS
) => {
  const { data, ...rest } = useQuery({
    queryKey: stockLocationKeys.purchaseOrders(id ?? '', input, pagination),
    queryFn: () =>
      gqlClient.request(GetStockLocationPurchaseOrders, {
        id: id!,
        input,
        pagination,
      }),
    enabled: !!id,
  });

  return {
    purchaseOrders: data?.stockLocation?.materialsList?.purchaseOrders,
    ...rest,
  };
};

export default useGetStockLocationPurchaseOrders;
